import React from 'react';

const CharacterIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 17 21"
    fill="#0a3887"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1633_1367)">
      <path
        d="M15.9597 20.8272C15.8279 20.8272 15.7201 20.7171 15.7201 20.5826C15.7201 18.5022 14.904 16.4082 13.4809 14.836C12.0152 13.2162 10.1048 12.3248 8.09856 12.3248C3.89706 12.3248 0.478343 15.8143 0.478343 20.1029C0.478343 20.2374 0.37051 20.3475 0.238714 20.3475C0.106918 20.3475 -0.000915527 20.2374 -0.000915527 20.1029C-0.000915527 15.5439 3.63213 11.8356 8.09856 11.8356C10.2393 11.8356 12.2748 12.7827 13.8324 14.5044C15.3354 16.1663 16.198 18.3812 16.198 20.5839C16.198 20.7185 16.0902 20.8285 15.9584 20.8285L15.9597 20.8272Z"
        fill="#ECD8FB"
      />
      <path
        d="M8.21 14.563C8.0782 14.563 7.97037 14.4529 7.97037 14.3184C7.97037 12.7897 8.84635 11.4389 10.2016 10.875C12.3037 9.99992 13.6216 7.85428 13.4805 5.53607C13.3154 2.8333 11.1947 0.667277 8.54681 0.500137C7.07043 0.405017 5.66593 0.921384 4.59293 1.9514C3.51859 2.98141 2.9275 4.37696 2.9275 5.88122C2.9275 6.01574 2.81967 6.12581 2.68787 6.12581C2.55608 6.12581 2.44824 6.01574 2.44824 5.88122C2.44824 4.26553 3.10989 2.70285 4.2641 1.59538C5.43695 0.471601 6.96792 -0.089607 8.57743 0.0123074C11.4663 0.195753 13.7801 2.55745 13.9598 5.50617C14.1142 8.03501 12.6764 10.375 10.3826 11.3289C9.20846 11.8167 8.44963 12.9908 8.44963 14.3197C8.44963 14.4543 8.3418 14.5643 8.21 14.5643V14.563Z"
        fill="#ECD8FB"
      />
      <path
        d="M8.20998 20.0186C7.34199 20.0186 6.63641 19.2984 6.63641 18.4124C6.63641 17.5264 7.34199 16.8062 8.20998 16.8062C9.07797 16.8062 9.78355 17.5264 9.78355 18.4124C9.78355 19.2984 9.07797 20.0186 8.20998 20.0186ZM8.20998 17.2968C7.60691 17.2968 7.11567 17.7982 7.11567 18.4138C7.11567 19.0293 7.60691 19.5308 8.20998 19.5308C8.81305 19.5308 9.30429 19.0293 9.30429 18.4138C9.30429 17.7982 8.81305 17.2968 8.20998 17.2968Z"
        fill="#ECD8FB"
      />
      <path
        d="M8.0995 9.52671C6.0906 9.52671 4.45447 7.85804 4.45447 5.80616C4.45447 3.75428 6.08927 2.08697 8.0995 2.08697C10.1097 2.08697 11.7445 3.75564 11.7445 5.80616C11.7445 7.85668 10.1097 9.52671 8.0995 9.52671ZM8.0995 2.57615C6.3542 2.57615 4.93373 4.02606 4.93373 5.80616C4.93373 7.58627 6.3542 9.03753 8.0995 9.03753C9.8448 9.03753 11.2653 7.58762 11.2653 5.80616C11.2653 4.0247 9.8448 2.57615 8.0995 2.57615Z"
        fill="#ECD8FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1633_1367">
        <rect width="16.199" height="20.8272" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CharacterIcon;
